import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Typography, Divider, withStyles } from '@material-ui/core';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { WithStyles } from '@material-ui/core/styles';
import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  sections: SidebarSection[];
  isExpanded: boolean;
}

export interface ListItemRoles {
  admin: ListItemRole;
  owner: ListItemRole;
  manager: ListItemRole;
}

export interface ListItemRole {
  key: string;
  title: string;
  sections: SidebarSection[];
}

export interface SidebarSection {
  sectionLabel?: string;
  items: ListItemRoleItem[];
}

export interface ListItemRoleItem {
  label: string;
  icon: React.ReactElement;
  iconActive: React.ReactElement;
  to: string;
}

const SidebarListItems = ({ classes, history, sections, isExpanded }: Props): React.ReactElement => {
  return (
    <div className={classes.root}>
      <List className={classes.list} component="div" disablePadding>
        {sections.map((section, sectionIndex) => (
          <div key={section.sectionLabel || `section-${sectionIndex}`}>
            {section.sectionLabel && (
              <>
                <Divider className={classes.sectionDivider} />
                {isExpanded && (
                  <Typography variant="overline" className={classes.sectionHeader}>
                    {section.sectionLabel}
                  </Typography>
                )}
              </>
            )}
            {section.items.map((item) => {
              const isActive = history.location.pathname === item.to || (item.to !== '/' && history.location.pathname.startsWith(item.to + '/'));
              const isExactActive = history.location.pathname === item.to;

              return (
                <ListItem
                  key={item.to}
                  button
                  className={`${classes.listItem} ${isActive || isExactActive ? classes.activeListItem : ''}`}
                  onClick={() => history.push(item.to)}>
                  {isExpanded ? (
                    <>
                      <ListItemIcon className={classes.listItemIcon}>{isActive || isExactActive ? item.iconActive : item.icon}</ListItemIcon>
                      <ListItemText primary={item.label} className={classes.listItemText} />
                    </>
                  ) : (
                    <ListItemIcon className={classes.listItemIcon}>{isActive || isExactActive ? item.iconActive : item.icon}</ListItemIcon>
                  )}
                </ListItem>
              );
            })}
          </div>
        ))}
      </List>
    </div>
  );
};

export default withRouter(withStyles(styles)(SidebarListItems));
